import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Activity } from 'lucide-react';

export const meta = {
  id: 'monitor_summary',
  category: 'monitoring',
  titleKey: 'dashboard.widgets.monitorSummary',
  descriptionKey: 'dashboard.widgets.monitorSummaryDesc',
  defaultSize: 'sm',
  icon: Activity,
};

export default function MonitorSummaryWidget({ ctx }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const monitorSummary = ctx?.monitorSummary;
  const monitorTotal = parseInt(monitorSummary?.total) || 0;
  if (monitorTotal === 0) return null;

  const monitorWarning = parseInt(monitorSummary?.warning) || 0;
  const monitorCritical = parseInt(monitorSummary?.critical) || 0;
  const monitorHealthy = parseInt(monitorSummary?.healthy) || 0;

  return (
    <div className="card" style={{ cursor: 'pointer', height: '100%' }} onClick={() => navigate('/monitor')}>
      <div className="card-header">
        <div className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Activity size={16} />
          {t('dashboard.monitoring')}
        </div>
      </div>
      <div style={{ padding: '16px 20px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {monitorCritical > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#ef4444', flexShrink: 0 }} />
              <span style={{ fontSize: 13, flex: 1 }}>{t('dashboard.monitorCritical')}</span>
              <span style={{ fontSize: 20, fontWeight: 700, color: '#ef4444' }}>{monitorCritical}</span>
            </div>
          )}
          {monitorWarning > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#f59e0b', flexShrink: 0 }} />
              <span style={{ fontSize: 13, flex: 1 }}>{t('dashboard.monitorWarning')}</span>
              <span style={{ fontSize: 20, fontWeight: 700, color: '#f59e0b' }}>{monitorWarning}</span>
            </div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#22c55e', flexShrink: 0 }} />
            <span style={{ fontSize: 13, flex: 1 }}>{t('dashboard.monitorHealthy')}</span>
            <span style={{ fontSize: 20, fontWeight: 700, color: '#22c55e' }}>{monitorHealthy}</span>
          </div>
          <div style={{ borderTop: '1px solid var(--c-border)', paddingTop: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 12, color: 'var(--c-text-muted)' }}>{t('dashboard.monitorTotal')}</span>
            <span style={{ fontSize: 14, fontWeight: 600 }}>{monitorTotal}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
